// Mock data for water smart meters
export const mockSmartWaterMeters = [
  {
    deviceId: "WTR001",
    location: "Building A, Floor 1",
    status: "Healthy",
    batteryLevel: 87,
    signalStrength: 92,
    lastCommunication: "2024-12-15T14:30:00Z",
    firmwareVersion: "v3.5.2",
    readings: {
      pressure: 320,
      flowRate: 12.5,
      temperature: 18.2,
      phLevel: 7.2,
      totalVolume: 4567.9
    },
    maintenanceStatus: {
      lastMaintenance: "2024-09-10",
      nextScheduled: "2026-01-10", 
      alerts: []
    }
  },
  {
    deviceId: "WTR002",
    location: "Building A, Floor 2",
    status: "Warning",
    batteryLevel: 42,
    signalStrength: 78,
    lastCommunication: "2024-12-15T13:45:00Z",
    firmwareVersion: "v3.5.1",
    readings: {
      pressure: 305,
      flowRate: 18.7,
      temperature: 19.3,
      phLevel: 6.8,
      totalVolume: 3892.5
    },
    maintenanceStatus: {
      lastMaintenance: "2024-08-15",
      nextScheduled: "2026-02-15", 
      alerts: ["Battery replacement needed"]
    }
  },
  {
    deviceId: "WTR003",
    location: "Building B, Floor 1",
    status: "Critical",
    batteryLevel: 12,
    signalStrength: 31,
    lastCommunication: "2024-12-14T09:15:00Z",
    firmwareVersion: "v3.4.9",
    readings: {
      pressure: 290,
      flowRate: 9.8,
      temperature: 20.1,
      phLevel: 8.5,
      totalVolume: 2938.7
    },
    maintenanceStatus: {
      lastMaintenance: "2024-07-20",
      nextScheduled: "2026-01-20", 
      alerts: ["Communication failure", "Battery critical", "Maintenance overdue"]
    }
  },
  {
    deviceId: "WTR004",
    location: "Building B, Floor 2",
    status: "Healthy",
    batteryLevel: 95,
    signalStrength: 89,
    lastCommunication: "2024-12-15T14:25:00Z",
    firmwareVersion: "v3.5.2",
    readings: {
      pressure: 325,
      flowRate: 12.4,
      temperature: 18.5,
      phLevel: 7.0,
      totalVolume: 3245.8
    },
    maintenanceStatus: {
      lastMaintenance: "2024-10-05",
      nextScheduled: "2026-02-05", 
      alerts: []
    }
  },
  {
    deviceId: "WTR005",
    location: "Building C, Floor 1",
    status: "Warning",
    batteryLevel: 56,
    signalStrength: 68,
    lastCommunication: "2024-12-15T11:05:00Z",
    firmwareVersion: "v3.5.0",
    readings: {
      pressure: 310,
      flowRate: 14.9,
      temperature: 19.8,
      phLevel: 7.5,
      totalVolume: 4123.6
    },
    maintenanceStatus: {
      lastMaintenance: "2024-08-25",
      nextScheduled: "2026-02-25", 
      alerts: ["Firmware update required"]
    }
  },
  {
    deviceId: "sm-10023",
    location: "Building D, Floor 1",
    status: "Healthy",
    batteryLevel: 86,
    signalStrength: 90,
    lastCommunication: "2024-12-15T15:15:00Z",
    firmwareVersion: "v3.5.2",
    readings: {
      pressure: 318,
      flowRate: 11.8,
      temperature: 18.0,
      phLevel: 7.1,
      totalVolume: 4125.6
    },
    maintenanceStatus: {
      lastMaintenance: "2024-10-15",
      nextScheduled: "2026-02-15", 
      alerts: []
    }
  },
  {
    deviceId: "sm-10045",
    location: "Building E, Floor 2",
    status: "Warning",
    batteryLevel: 39,
    signalStrength: 63,
    lastCommunication: "2024-12-15T11:45:00Z",
    firmwareVersion: "v3.5.0",
    readings: {
      pressure: 302,
      flowRate: 10.3,
      temperature: 19.2,
      phLevel: 7.8,
      totalVolume: 3845.2
    },
    maintenanceStatus: {
      lastMaintenance: "2024-08-05",
      nextScheduled: "2026-01-05", 
      alerts: ["Unusual water flow pattern"]
    }
  }
];
